import { render, staticRenderFns } from "./MessageConfirmation.vue?vue&type=template&id=0232b0c6"
import script from "./MessageConfirmation.vue?vue&type=script&lang=js"
export * from "./MessageConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports